import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import ServicePage from '../../../shared/servicePage/ServicePage';
import getImageData from './GetImage.json';
import * as PageConstants from '../../../../constants/PageTitle';
import '../../Technical.css';

class GetImage extends Component {
    render() {
        var back = this.props.match.path.substring(0, this.props.match.path.lastIndexOf("/"));
        var parts = back.split('/');
        var webServicePath = parts[parts.length - 1];

        if (webServicePath == PageConstants.IMG_DELIVERY2)
            getImageData.parent = PageConstants.IMG_DELIVERY2_TITLE;

        return (
            <div className="technical-main">
                <Breadcrumbs />
                <ServicePage ServiceData={getImageData} backLink={back} />
            </div>
        )
    }
}

GetImage.propTypes = {
    match:PropTypes.object,
    path: PropTypes.string
  }

export default GetImage;